import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getUserDecision } from "../decision";
import { isCrawler } from "../utils";
/**
 * Prevent any predecision and user decision and force to reuse existing consent or all for crawlers.
 * This could be e.g. be configured by a dynamic hook or on server-side via a localized variable.
 */

var preDecisionGatewayIsPreventPreDecision = function preDecisionGatewayIsPreventPreDecision(preventPreDecision) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var decisionCookieName, userDecision;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              decisionCookieName = _ref.decisionCookieName;
              userDecision = getUserDecision(decisionCookieName);
              return _context.abrupt("return", preventPreDecision && userDecision === false ? isCrawler() ? // For crawlers we need to explicitly allow cookies on all pages
              "all" : "consent" : false);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

export { preDecisionGatewayIsPreventPreDecision };